import { Injectable, inject } from '@angular/core';
import { RoutingService } from '@rogers/self-serve-utils/routing';
import { UserInformationStateFacade } from '@rci/self-serve-fido/state/user-information/user-information-state.facade';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private readonly userInformationStateFacade = inject(UserInformationStateFacade);
  private readonly routingService = inject(RoutingService);

  setAccountNumberAndNavigate(accountNumber: string, url: string, phoneNumber = '', skipAccountSelectorModal = false) {
    this.userInformationStateFacade.updateSelectedAccountNumber(accountNumber);
    if (phoneNumber) {
      this.userInformationStateFacade.updateSelectedSubscriberNo(phoneNumber);
    }
    setTimeout(() => this.routingService.navigate(url, null, { skipAccountSelectorModal }));
  }
}
